module.exports = "./img/0e3578dcda2ec9c8543048f20055e53e.jpg";